// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import * as types from './actionTypes';

export function setFundraiseFormField(field, value) {
  return {
    type: types.SET_FUNDRAISE_FORM_FIELD,
    field,
    value,
  };
}

export function resetError() {
  return {
    type: types.RESET_ERROR,
  };
}

export function validatPhoneNumber(data, dataForValidBank, dataForNextRequest) {
  return {
    type: types.VALIDATE_PHONE_NUMBER_FUNDRAISE,
    data,
    dataForValidBank,
    dataForNextRequest,
  };
}

export function validateBankAccount(data, dataForNextRequest) {
  return {
    type: types.VALIDATE_BANK_ACCOUNT,
    data,
    dataForNextRequest,
  };
}

export function setError(error) {
  return {
    type: types.SET_ERROR,
    error,
  };
}

export function setIsButtonPressed(isButtonPressed) {
  return {
    type: types.SET_IS_BUTTON_PRESSED,
    isButtonPressed,
  };
}


export function getFundraisePageData(data) {
  return {
    type: types.GET_FUNDRAISE_PAGE_DATA,
    ...data
  };
}

export function getFundraisePageDataSuccess(data) {
  return {
    type: types.GET_FUNDRAISE_PAGE_DATA_SUCCESS,
    data,
  };
}

export function registerCharity(data) {
  return {
    type: types.REGISTER_CHARITY,
    data,
  };
}

export function registerCharitySuccess() {
  return {
    type: types.REGISTER_CHARITY_SUCCESS,
  };
}

export function resetStatus() {
  return {
    type: types.RESET_STATUS,
  };
}
